module.exports = __webpack_public_path__ + "static/media/modal-2.b2fa9433.jpg";